<script>
	export let data = {};
</script>

<div class="UIText" style="text-align:{data.align}">
	<div class="UIText-box _{data.style}">
		{@html data.text.split("\n").join("<br>")}
	</div>
</div>

<style global>
	.UIText {
		padding: 1em 0;
		line-height: 2;
		max-width: 720px;
		margin: 0 auto;
		font-size: 1.1em;
		color: #524e4e;
	}
	.UIText-box._frame {
		border: 1px dashed #ccc;
		background: #f6f6f6;
		padding: 1em;
		font-size: 1em;
	}
	:global(.pc) .UIText-box._frame {
		padding: 1.75em;
	}
	.UIText-box._indent {
		margin-left: 1.5em;
		padding: 0 1.5em;
		border-left: 1px solid #ccc;
		font-size: 1em;
	}
	.UIText :global(u) {
		text-decoration: none;
		background: linear-gradient(transparent 50%, #fe6 50%);
	}
	.UIText :global(s) {
		opacity: 0.5;
	}
</style>
